const defaultState = {
	plants: [],
	msgTypes: [],
	useYnList: [],
	gridUseYnList: [],
	systems: [],
	gridScrType: [], //System : C, L
	gridMsgTypes: [],
	searchParams: {
		plantCd: '',
		msgLang: 'ko_KR',
		parentScrId: null,
		msgLoc: null,
		msgKey: null,
		msgText: null,
		msgType: 'U' //메뉴명
	},
	menuTree: [],
	selectedMenu: {},
	menus: [],
	menuKey: null,
	dicMsgManagements: [],
	groups: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	popup: {
		groups: {
			currentPage: 1,
			pageUnit: 10,
			totalSize: 0
		}
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
